module.exports = __webpack_public_path__ + "static/media/canvas_strap_green.02cd6370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/canvas_strap_green.png
// module id = 104
// module chunks = 0